var map = {
	"./partner1.png": 3547,
	"./partner10.png": 6357,
	"./partner11.png": 1146,
	"./partner12.png": 2368,
	"./partner2.png": 3329,
	"./partner3.png": 7343,
	"./partner4.png": 5677,
	"./partner5.png": 3394,
	"./partner6.png": 9871,
	"./partner7.png": 841,
	"./partner8.png": 3716,
	"./partner9.png": 6551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6399;